module.exports = __webpack_public_path__ + "img/seal.f36d99af.webp";